import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Promotions } from '../../models'
import { AccountingCodesService } from '../../services'

const log = new Logger('AccountingCodesDetailResolver')
@Injectable({ providedIn: 'root' })
export class AccountingCodesDetailResolver
  implements Resolve<Observable<Promotions>> {
  constructor(
    private accounting: AccountingCodesService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let id = route.params['id']
    
    return this.accounting.getDetail(id).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/accounting-codes']))
    )
  }
}
